import z from 'zod'
import {ERROR_DEFAULT} from 'features/common/core/errors'
import api from 'features/common/transport'
import {Country} from 'features/common/core/entitites'

const sendCodeResponseSchema = z.object({
    balance: z.array(
        z.object({
            amount: z.number(),
            month: z
                .literal('January')
                .or(z.literal('February'))
                .or(z.literal('March'))
                .or(z.literal('April'))
                .or(z.literal('May'))
                .or(z.literal('June'))
                .or(z.literal('July'))
                .or(z.literal('August'))
                .or(z.literal('September'))
                .or(z.literal('October'))
                .or(z.literal('November'))
                .or(z.literal('December')),
        }),
    ),
    currency: z.string(),
})

const getStatistics = async (args: {
    country: Country
    stripeAccountId: string
}) => {
    const {country, stripeAccountId} = args
    const res = await api.get(`reports/${country}/${stripeAccountId}`)

    const parseRes = sendCodeResponseSchema.safeParse(await res.json())
    if (parseRes.success) {
        return parseRes.data
    }

    throw new Error(ERROR_DEFAULT)
}
export default getStatistics
